import numeral from "numeral";

export default value => (value ? numeral(value).format("0[.]00%") : "N/A");
